import { openBuyAnalyticsModal } from './openBuyAnalyticsModal';
import { sendSoprAnalytics } from './sendSoprAnalytics';
import { selectIsAuthenticated } from '../../selectors';
import { IThunkActionCreator } from '../../store';
import { requestAuthentication } from '../authentication';

export const startBuyAnalytics = (): IThunkActionCreator => {
  return (dispatch, getState): void => {
    const state = getState();

    dispatch(sendSoprAnalytics('buy_report'));

    const isAuthenticated = selectIsAuthenticated(state);

    if (!isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: openBuyAnalyticsModal,
          viewData: { headingType: 'buyCommercialAnalyticsPermission' },
        }),
      );

      return;
    }
    dispatch(openBuyAnalyticsModal());
  };
};
